import {createAction, props} from '@ngrx/store';
import {Notification} from '../../../shared/models/notification';
import {NotificationStats} from '../../../shared/models/notification-stats';

export const notificationsInit = createAction(
  '[Core] Notifications Init'
);

export const notificationsDisconnect = createAction(
  '[Core] Notifications Disconnect'
);

export const getNotifications = createAction(
  '[Core] Get Notifications',
  props<{page: number}>()
);

export const getNotificationsSuccess = createAction(
  '[Core/API] Get Notifications Success',
  props<{notifications: Notification[], stats: NotificationStats}>()
);

export const getNotificationsFailure = createAction(
  '[Core/API] Get Notifications Failure',
  props<{error: any}>()
);

export const loadMoreNotifications = createAction(
  '[Core] Load More Notifications'
);

export const loadMoreNotificationsSuccess = createAction(
  '[Core/API] Load More Notifications Success',
  props<{notifications: Notification[], stats: NotificationStats}>()
);

export const loadMoreNotificationsFailure = createAction(
  '[Core/API] Load More Notifications Failure',
  props<{error: any}>()
);

export const setNotificationsStats = createAction(
  '[Core] Set Notifications Stats',
  props<{stats: NotificationStats}>()
);

export const updateNotificationsStatus = createAction(
  '[Core] Update Notifications Status',
  props<{notificationsIds: number[]}>()
);

export const updateNotificationsStatusSuccess = createAction(
  '[Core/API] Update Notifications Status Success',
  props<{notifications: Notification[]}>()
);

export const updateNotificationsStatusFailure = createAction(
  '[Core/API] Update Notifications Status Failure',
  props<{error: any}>()
);

export const pushNotification = createAction(
  '[Core] Push Notification',
  props<{notification: Notification}>()
);

export const pushNotificationSuccess = createAction(
  '[Core] Push Notification Success',
  props<{notifications: Notification[]}>()
);

export const updateNotification = createAction(
  '[Core] Update Notification',
  props<{notification: Notification}>()
);

export const getNotificationByIds = createAction(
  '[Core] Get Notification By Ids',
  props<{ids: number[]}>()
);

export const getNotificationByIdsSuccess = createAction(
  '[Core/API] Get Notification By Ids Success',
  props<{notifications: Notification[]}>()
);

export const getNotificationByIdsFailure = createAction(
  '[Core/API] Get Notification By Ids Failure',
  props<{error: any}>()
);


export type NotificationActionsUnion = ReturnType<
  typeof notificationsInit |
  typeof notificationsDisconnect |
  typeof getNotifications |
  typeof getNotificationsSuccess |
  typeof getNotificationsFailure |
  typeof setNotificationsStats |
  typeof loadMoreNotifications |
  typeof loadMoreNotificationsSuccess |
  typeof loadMoreNotificationsFailure |
  typeof updateNotificationsStatus |
  typeof updateNotificationsStatusSuccess |
  typeof updateNotificationsStatusFailure |
  typeof pushNotification |
  typeof pushNotificationSuccess |
  typeof updateNotification |
  typeof getNotificationByIds |
  typeof getNotificationByIdsSuccess |
  typeof getNotificationByIdsFailure
  >;
